import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { setUserRoleInStorage, getUserRoleFromStorage } from "./storageUtils";
import { set } from "react-hook-form";

const API_URL = process.env.REACT_APP_API_URL;

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [userRole, setUserRole] = useState(getUserRoleFromStorage());
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      if (userRole && isAuthenticated) return;
      
        axios
          .get(`${API_URL}/get-user`, { withCredentials: true })
          .then(({ data }) => {
            if (data?.role) {
              setUserRoleInStorage(data.role);
              setIsAuthenticated(true);
              setUserRole(data.role);
            }
          })
          .catch((error) => {
            setIsAuthenticated(false); 
            localStorage.removeItem("userRole");
            setUserRole(null);
            console.error("Unable to fetch user:", error.message);
          }).finally(() => setLoading(false));
      }, [userRole]);
      
  return (
    <AuthContext.Provider value={{ userRole, setUserRole, isAuthenticated, setIsAuthenticated, loading, setLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
